import { connect } from 'react-redux';
import { getCoordinatorOptions } from 'selectors/options';
import SelectOptionField from './SelectOptionField';


const mapStateToProps = (state, props) => {
  return {
    name: 'coordinator',
    label: props.label || 'Coordinator',
    options: getCoordinatorOptions(state),
  }
}

export default connect(
  mapStateToProps,
)(SelectOptionField);

